import {
  hasAspireReconciliationFlag,
  type OrganisationConfiguration,
} from "@thalamos/aspire-common";

/**
 * Determines whether the Aspire-level reconciliation flow (NHS number click)
 * is available for the current user and patient.
 *
 * Requires:
 * - `reconciliationViaNhsNumberEnabled` org flag is on
 * - `nhsNumberEnabled` org flag is on (dependency)
 * - `pdsEnabled` org flag is on (dependency)
 * - `pdsEndUserOrganisationODSCode` is configured
 * - Patient does NOT already have an NHS number
 */
export function canReconcileViaAspireFlag({
  sessionOrganisationConfiguration,
  patientHasNhsNumber,
}: {
  sessionOrganisationConfiguration:
    | OrganisationConfiguration
    | null
    | undefined;
  patientHasNhsNumber: boolean;
}): boolean {
  if (!sessionOrganisationConfiguration) return false;
  if (!hasAspireReconciliationFlag(sessionOrganisationConfiguration))
    return false;
  if (patientHasNhsNumber) return false;

  return true;
}
